<template>
  <div class="container">
    <v-header></v-header>
    <header-searchtwo></header-searchtwo>

    <div class="nav">
      <div class="item-body">
        <ul>
          <li :class="{'active':cartchoose==-1}" @click="choosecart(-1)">全部订单</li>
          <li :class="{'active':cartchoose==0}" @click="choosecart(0)">待确认</li>
          <li :class="{'active':cartchoose==1}" @click="choosecart(1)">待发货</li>
          <li :class="{'active':cartchoose==2}" @click="choosecart(2)">待收货</li>
        </ul>
      </div>
    </div>

    <template v-if="orderList.length==0">
      <div class="cart_empty">您的订单还是空的哦，快去挑选您喜欢的东西吧.</div>
    </template>

    <template v-else>
      <div class="contentt">
        <div class="body-container">
          <div class="item-body" v-for="(item,itemIndex) in orderList" :key="itemIndex">
            <div class="item-header">
              <div class="item-header-left">
                <div class="item-number-title">订单编号：</div>
                <div class="item-number">{{item.order_no}}</div>
              </div>
              <div class="item-header-right">{{item.created_at}}</div>
            </div>
            <div class="item-line"></div>
            <div class="item_box">
              <div class="item_box_left">
                <div class="list-item">
                  <div class="order-left">
                    <img class="order-img" :src="item.product_image" />
                    <div class="order-info">
                      <div class="info-title">{{item.product_title}}</div>
                      <div
                        class="info-size"
                        v-for="(attr,index) in item.attrs"
                        :key="index"
                        v-show="attr.product_key !='生产类型' "
                      >{{attr.product_key}}：{{attr.product_value}}</div>
                    </div>
                  </div>
                  <div class="order-number">X {{item.count}}</div>
                </div>
              </div>
              <div class="order-type-item">
                <div class="order-type" v-show="item.is_customized==0">不定制</div>
                <div class="order-type" v-show="item.is_customized==1">定制</div>

                <div class="line"></div>
                <div class="order-type" v-show="item.order_type==0">大货</div>
                <div class="order-type" v-show="item.order_type==1">打样</div>
                <div class="line"></div>
                <div class="order-type" v-show="item.state==0">待确认</div>
                <div class="order-type" v-show="item.state==1">待发货</div>
                <div class="order-type" v-show="item.state==2">待收货</div>
                <div class="order-type" v-show="item.state==3">售后中</div>
                <div class="order-type" v-show="item.state==4">已收货</div>
                <div class="order-type" v-show="item.state==99">交易成功</div>
              </div>
              <div class="order-right">
                <a class="order-detail-title" @click="orderDetail(itemIndex)" href="#">订单详情</a>
                <div
                  class="order-detail-title"
                  @click="applyClick(item.id)"
                  v-show="item.state<3"
                >申请售后</div>
                <el-button
                  v-show="item.state<1"
                  type="text"
                  @click="cancelOrder(itemIndex)"
                  style="color: black;fontSize:10px;font-weight:normal;line-height:0;color:rgba(0, 0, 0, 0.65)"
                >取消订单</el-button>
                <el-button
                  v-show="item.state==3"
                  type="text"
                  @click="cancelApply(itemIndex)"
                  style="color: black;fontSize:10px;font-weight:normal;line-height:0;color:rgba(0, 0, 0, 0.65);"
                >取消售后</el-button>

                <!-- <a class="order-detail-title" @click="cancelOrder(itemIndex)" href="#">取消订单</a> -->
              </div>
            </div>
          </div>
        </div>
        <div class="paging_box">
          <el-pagination
            @current-change="currentChange"
            :current-page="currentPage"
            :page-size="10"
            background
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <right-customer></right-customer>
    </template>

    <v-footer></v-footer>

    <el-dialog title="申请售后" :visible.sync="dialogVisible" width="560px">
      <el-form ref="form" label-width="100px">
        <el-form-item label="申请原因:">
          <el-select v-model="formData.reason" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请理由:">
          <el-input
            v-model="formData.grounds"
            type="textarea"
            placeholder="请输入内容"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-form-item label="上传图片">
              <el-upload
                action="https://mall-api.senkoo.cn/api/upload"
                list-type="picture-card"
                :on-remove="handleRemove"
                :on-success="handleAvatarSuccess"
                :file-list="formData.image"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span class="dialog-footer" style="margin-left:80px">
        <el-button type="danger" round @click="clickDialog(1)">确 定</el-button>
        <el-button round @click="clickDialog(0)">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import header from "../header";
import footer from "../footer";
import headersearchtwo from "../headersearchtwo";
import rightCustomer from "../rightCustomer";

export default {
  name: "myOrder",
  props: ["proshows", "licolors"],
  watch: {
    licolors: function(a, b) {}
  },
  components: {
    "v-header": header,
    "v-footer": footer,
    "header-searchtwo": headersearchtwo,
    "right-customer": rightCustomer
  },
  data() {
    return {
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      orderList: [],
      total: 0,
      currentPage: 1,
      cartchoose: -1,
      options: [
        {
          value: "成品效果不好",
          label: "成品效果不好"
        },
        {
          value: "商品损坏",
          label: "商品损坏"
        },
        {
          value: "发错件",
          label: "发错件"
        },
        {
          value: "质量问题",
          label: "质量问题"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      value: "",
      formData: {
        order_id: "",
        reason: "",
        grounds: "",
        image: [] // 这里的必须是一个数组，才能正确回显，并且对象中要有name，url，uid
      }
    };
  },
  methods: {
    applyClick(id) {
      this.dialogVisible = true;
      this.formData.order_id = id;
    },
    // 选择购物车2大类之一
    choosecart(index) {
      this.cartchoose = index;
      this.currentPage = 1;
      this.getOrderList(this.currentPage, this.cartchoose);
    },
    currentChange(page) {
      this.getOrderList(page, this.cartchoose);
    },
    getOrderList(page, state) {
      this.$http
        .getMyOrder({ limit: 10, page: page, state: state })
        .then(res => {
          if (res.code == 200) {
            this.total = res.page.total;
            this.orderList = res.orders.map(order => ({
              ...order
            }));
          }
        });
    },
    orderDetail(index) {
      let detail = `detail${index}`;
      console.log(this.orderList[index]);
      localStorage.setItem(detail, JSON.stringify(this.orderList[index]));
      this.$router.push({
        path: "orderDetails",
        query: {
          detail: detail
        }
      });
    },
    cancelOrder(index) {
      this.$confirm("你确定要取消该订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .cancelOrder({ order_no: this.orderList[index].order_no })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  message: "取消订单成功",
                  type: "success"
                });
                this.orderList.splice(index, 1);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
        })
        .catch(() => {});
    },
    cancelApply(index) {
      this.$confirm("你确定要取消该订单售后吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .cancelAfterService({ order_id: this.orderList[index].id })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  message: "取消售后成功",
                  type: "success"
                });
                this.currentPage = 1;
                this.getOrderList(this.currentPage, this.cartchoose);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
        })
        .catch(() => {});
    },

    clickDialog(index) {
      switch (index) {
        case 0:
          this.dialogVisible = false;

          this.formData = {
            order_id: "",
            reason: "",
            grounds: "",
            image: [] // 这里的必须是一个数组，才能正确回显，并且对象中要有name，url，uid
          };
          break;
        case 1:
          this.dialogVisible = false;
          console.log(this.formData);
          if (
            this.formData.reason.length == 0 ||
            this.formData.reason.grounds == 0 ||
            this.formData.reason.image == 0
          ) {
            this.$message({
              message: "将信息填写完整",
              type: "warning"
            });
            return;
          }

          this.$http
            .postafterService({
              order_id: this.formData.order_id,
              reason: this.formData.reason,
              grounds: this.formData.grounds,
              image: JSON.stringify(this.formData.image)
            })
            .then(res => {
              if (res.code == 200) {
                this.currentPage = 1;
                this.getOrderList(this.currentPage, this.cartchoose);

                this.formData = {
                  order_id: "",
                  reason: "",
                  grounds: "",
                  image: [] // 这里的必须是一个数组，才能正确回显，并且对象中要有name，url，uid
                };
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });

          break;

        default:
          break;
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code === 200) {
        this.formData.image.push({
          name: res.url,
          url: res.url,
          uid: this.formData.image.length
        });
        console.log(this.formData.image);
      } else {
        this.$message.error(res.msg);
      }
    },

    // 正文图片上传,删除操作
    handleRemove(file, fileList) {
      // file是点击删除的文件，fileList时删除后剩下的文件列表
      this.formData.image = fileList;
      console.log(this.formData.image);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  filters: {},
  computed: {},
  created() {
    this.getOrderList(1);
  }
};
</script>

<style lang='scss' scoped>
.container {
  width: 100%;
}

.nav {
  width: 100%;
  height: 56px;
  background-color: #fff;

  position: relative;
}

.active {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ef2d23;
}

.item-body {
  width: 1200px;
  margin: 0 auto;
}

ul {
  list-style: none;
  position: absolute;
  bottom: 0;
}

li.proshowstyle {
  // float: left;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: rgba(239, 45, 35, 1);
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}

li {
  float: left;
  cursor: pointer;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.headerType {
  float: left;
  cursor: pointer;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

li:hover {
  color: #e7001e;
}

.colors {
  color: #e7001e;
}

.cart_empty {
  /* position: absolute;*/
  width: 1200px;
  line-height: 40px;
  margin: 0 auto;
  text-align: center;
}

.contentt {
  .body-container {
    width: 100%;
    height: 100%;
  }
  .paging_box {
    float: right;
    position: relative;
    width: 1200px;
    margin: 10px 320px 0 0;
    display: flex;
    justify-content: flex-end;
  }
}

.item-body {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  flex-direction: column-reverse;
}

.item-header {
  width: 1200px;
  height: 44px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin: 24px 0 0 0;
}

.item-header-left {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.item-number-title {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 20px;
  text-align: center;
  margin: 12px 0 0 24px;
}

.item-number {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
  margin: 12px 0 0 0;
}

.item-header-right {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 20px;
  margin: 12px 24px 0 0;
}

.item-line {
  width: 1200px;
  height: 1px;
  background: rgba(232, 232, 232, 1);
}

.item_box {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item_box_left {
  width: 800px;
  height: auto;
  /* flex-direction: row;*/
}

.list-item {
  /*  width: 700px;*/
  height: auto;

  display: flex;
  margin-bottom: 10px;
  /*  flex-wrap: nowrap;*/
  /*  justify-content: space-between;
    */
}

.order-left {
  width: 600px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.order-img {
  width: 96px;
  height: 96px;
  background-color: #d1d1d1;
  margin: 16px 0 0 24px;
  filter: invert(0.08);
}

.order-info {
  width: 470px;
  /*  max-width: 430px;*/
  height: 96px;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  margin: 16px 0 0 16px;
  text-align: left;
}

.info-title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;

  // border: 1px solid red;
}

.info-size {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
}

.order-number {
  width: 200px;
  /* background: navy;*/
  font-size: 14px;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: center;
  padding: 50px 0 0 0;
}

.order-type-item {
  width: 250px;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(217, 217, 217, 1);
  flex-direction: row;
  display: flex;
  justify-content: space-around;
}

.order-type {
  width: 70px;
  height: 40px;

  text-align: center;
}

.line {
  width: 2px;
  height: 10px;
  background: rgba(232, 232, 232, 1);
  margin-top: 15px;
}

.item-type {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  text-align: center;
}

.item-type2 {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  text-align: center;
}

.order-right {
  width: 100px;
  flex-direction: column-reverse;
  justify-content: space-between;
  /*height: 128px;*/
  text-align: center;
  /*    margin: 28px 40px 0 0;*/
}

.order-detail-title {
  line-height: 25px;
  outline: none;
  text-decoration: none;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}

.shopType {
  width: 1200px;
  height: 80px;
  position: relative;
  background-color: #fff;
  margin: 25px auto;
}

.typeTitle {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  padding: 16px 0 0 25px;
  position: absolute;
}
</style>
